export default {"src":"/_next/static/media/ytb.51c610e0.svg","height":28,"width":29};